import React, { useState, useEffect } from "react";
import api from "../Services/api";
import icoDownload from '../../assets/img/ico-download.svg';
import GA4React from "ga-4-react";

const RelatoriosAnuais = (props: any) => {

  const [relatorios, setRelatorios] = useState<any[]>([]);
  const [isloaded, setIsloaded] = useState(false);
  const [ga, setGa] = useState<GA4React>();
  const { REACT_APP_GOOGLE_GA_TAG } = process.env; 
  const sendEvent = (categoria: string, label: string) => {
    ga?.event(categoria, label, categoria)
  }

  function formatDateAno(dateUtc: any) {
    if (dateUtc) {
      let month = new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' });
      month = month.charAt(0).toUpperCase() + month.slice(1);
      return month + ' ' + new Date(dateUtc).getFullYear().toString();
    }
  }

  function newObject(data: any) {
    var relatorios: any[] = [];
    var resumos: any[] = [];

    var obj: any[] = [];;
    data.map((item: any) => {
      if (item.Tipo === "Relatório") {
        relatorios.push(item);
      } else if (item.Tipo === "Resumo") {
        resumos.push(item);
      }
      return true;
    });
    for (var i = 0; i < relatorios.length; i++) {
      var payload = { Title: "", URL: "", URLResume: "", UrlImage: "" };
      let relatorio = relatorios[i];
      let resumo = resumos.find(element => element.Title.includes(relatorio.Title));
      payload.Title = relatorio.Title;
      payload.URL = decodeURIComponent(relatorio.URL);
      payload.URLResume = resumo ? resumo.URL : "";
      payload.UrlImage = relatorio.UrlImage;
      obj.push(payload);
    };
    setRelatorios(obj);
    console.log('✌️ obj --->', obj);

  }

  useEffect(() => {
    if (!isloaded) {
      setIsloaded(true);
      try {
        const ga4react = new GA4React(
          REACT_APP_GOOGLE_GA_TAG ?? 'G-R0BM8HM4F8',
          { /* ga custom config, optional */ },
          [ /* additional code, optional */],
          3000 /* timeout, optional, defaults is 5000 */,
          /* { nonce: ['first-script-is-async','second-script'] } */
        );
        ga4react.initialize().then((ga4) => {
        }, (err) => {
          console.error(err)
        })
        setGa(ga4react);
      } catch (err) {
        console.error(err);
      }
    }
  }, [isloaded]);

  useEffect(() => {
    api
      .get("/ObterRelatorioAnualAtividades")
      .then((response) => {
        newObject(response.data.results);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, []);
  return (
    <div className="col-lg-10">
      <div className="row">

        {relatorios?.map((item: any, index: any) => (
          <div key={index} className="col-md-6">
            <div className="box-pdf mt-4 mb-10">
              <div className="container_1">
                <img src={item.UrlImage ? item.UrlImage : props.fileImg} alt="Organograma" className="mb-5 image" />
              </div>
              <div className="my-3">
                <span> <strong> {item.Title} </strong> </span> <br />
              </div>
              <a
                onClick={() => sendEvent("Relatorio_Anual_de_Informacoes", `Nº ${item?.ID} - ${item?.Title}`)}
                href={item.URL} target="_blank" className="d-flex mt-3" rel="noreferrer">

                <a href={item.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100" rel="noreferrer">
                  <img style={{ maxWidth: "80%" }} src={icoDownload} alt="Ícone" />
                </a>
                <span className="text ml-3">
                  Completo
                </span>
              </a>
              {item.URLResume !== "" && <a href={item.URLResume} target="_blank" className="d-flex mt-3" rel="noreferrer">

                <a
                  onClick={() => sendEvent("Relatorio_Anual_de_Informacoes", `Nº ${item?.ID} - ${item?.Title}`)}
                  href={item.URLResume} target="_blank" className="btn btn-primary rounded p-0 btn-100" rel="noreferrer">
                  <img style={{ maxWidth: "80%" }} src={icoDownload} alt="Ícone" />
                </a>
                <span className="text ml-3">
                  Versão resumida
                </span>
              </a>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default RelatoriosAnuais;

